import { render } from "./RattingFrontClient.vue?vue&type=template&id=39a1e58a&scoped=true"
import script from "./RattingFrontClient.vue?vue&type=script&lang=js"
export * from "./RattingFrontClient.vue?vue&type=script&lang=js"

import "./RattingFrontClient.vue?vue&type=style&index=0&id=39a1e58a&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a1e58a"]])

export default __exports__